export default __webpack_public_path__ + "static/media/iPhone-Premium-3.c545aace.png";